import React from 'react'
import UpdateAutomationRule from 'src/app/UpdateAutomationRule/UpdateAutomationRule'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { updateAutomationRuleRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const UpdateAutomationRuleAppRoute: AppRoute = {
  id: AppLocation.UpdateAutomationRule,
  routeProps: updateAutomationRuleRouteProps,
  component: <UpdateAutomationRule />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default UpdateAutomationRuleAppRoute
